import { render, staticRenderFns } from "./GestionRetiroIndependiente.vue?vue&type=template&id=48d5af75"
import script from "./GestionRetiroIndependiente.vue?vue&type=script&lang=js"
export * from "./GestionRetiroIndependiente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports